import { render } from "./AdvancedInitialWhatsappMessageConfig.vue?vue&type=template&id=adfac848&scoped=true"
import script from "./AdvancedInitialWhatsappMessageConfig.vue?vue&type=script&lang=js"
export * from "./AdvancedInitialWhatsappMessageConfig.vue?vue&type=script&lang=js"

import "./AdvancedInitialWhatsappMessageConfig.vue?vue&type=style&index=0&id=adfac848&scoped=true&lang=css"
import "./AdvancedInitialWhatsappMessageConfig.vue?vue&type=style&index=1&id=adfac848&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adfac848"]])

export default __exports__